import React from "react";
import BaseFormPage from "../../base/BaseFormPage";
import withRouter from "../../withRouter";
import SubscriptionFormPresenter from "./SubscriptionFormPresenter";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import InputFactory from "../../components/InputFactory";
import { Progress, dialog } from "../../nq-component";
import { Link } from "react-router-dom";
import NavBar from "../../components/navbar";
class SubscriptionFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new SubscriptionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase()
    );
    this.state = {
      object: {},
      submitting: false,
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "subscription";
  }

  closeDialog() {
    dialog.close();
  }

  render() {
    const { object, submitting } = this.state;
    console.log(object);

    return (
      <>
        <div className="sticky-top">
          <NavBar />
        </div>
        <div className="container-fluid p-4 relative overflow-auto">
          {submitting && (
            <div className="position-absolute top-50 start-50 translate-middle z-3">
              <Progress size="lg" />
            </div>
          )}
          <h1 className="fw-semibold">Manage Subscription</h1>
          <form className="row" onSubmit={this.onSubmitForm.bind(this)}>
            <div className="col-md-5 col-15 ">
              <div className="mb-4">
                <h5 className="fw-semibold">Details</h5>
                <div className="card  p-3">
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Listing
                    </label>
                    <InputFactory
                      type="Number"
                      field="listings"
                      object={object}
                      placeholder="Input number of listings"
                      onChange={this.onChange.bind(this)}
                      required={true}
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="form-label"
                    >
                      Price
                    </label>
                    <InputFactory
                      type="Number"
                      field="price"
                      object={object}
                      placeholder="Input price"
                      onChange={this.onChange.bind(this)}
                      required={true}
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={submitting}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
}
export default withRouter(SubscriptionFormPage);
